export default {"src":"/pro/_next/static/media/xag.e1072f0d.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};